// our-stores links: previous fix attempts deadlocked with target="_blank" in
// the menu template (capture-phase handler called stopImmediatePropagation +
// window.location.assign without preventDefault, racing the new-tab default
// action). target="_blank" has now been removed from the template and
// data-no-instant is rendered there directly, so no JS is needed here.


// Custom product image opener — replaces fancybox lightbox
document.addEventListener("DOMContentLoaded", function () {

  if (!document.querySelector('.product_section')) return;

  function isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }

function getCappedImageUrl(target) {
    var src = target.currentSrc || target.src;
    src = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(\.|_)/, '.');
    src = src.split('?')[0];
    var separator = src.indexOf('?') === -1 ? '?' : '&';
    
    if (isMobile()) {
      return src + separator + 'width=1500&quality=80';
    }
    return src + separator + 'width=2400';
  }
  // ===== MOBILE: open in same tab =====
  if (isMobile()) {
    var gallery = document.querySelector('.product_gallery');
    if (gallery) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartTime = 0;
      var touchMoved = false;

      gallery.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartTime = Date.now();
        touchMoved = false;
      }, { passive: true });

      gallery.addEventListener('touchmove', function(e) {
        var dx = Math.abs(e.touches[0].clientX - touchStartX);
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > 5 || dy > 5) touchMoved = true;
      }, { passive: true });

      gallery.addEventListener('touchend', function(e) {
        var target = e.target;
        if (target.tagName !== 'IMG') return;
        if (target.closest('.product_gallery_nav')) return;

        if (touchMoved) return;

        var duration = Date.now() - touchStartTime;
        if (duration > 300) return;

        var flkty = Flickity && Flickity.data(gallery);
        if (flkty && flkty.isAnimating) return;

        e.preventDefault();
        e.stopPropagation();

        window.location.href = getCappedImageUrl(target);
      });

      gallery.addEventListener('click', function(e) {
        var target = e.target;
        if (target.tagName !== 'IMG') return;
        if (target.closest('.product_gallery_nav')) return;

        if (touchMoved) {
          touchMoved = false;
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        window.location.href = getCappedImageUrl(target);
      });
    }
    return;
  }

  // ===== DESKTOP: custom lightbox overlay =====
  var overlay = document.createElement('div');
  overlay.id = 'pa-lightbox';
  overlay.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.9);z-index:99999;align-items:center;justify-content:center;cursor:zoom-out;';
  overlay.innerHTML = '<button id="pa-lightbox-close" style="position:absolute;top:20px;right:30px;background:transparent;border:none;color:#fff;font-size:40px;line-height:1;cursor:pointer;font-family:Arial,sans-serif;padding:0;width:40px;height:40px;z-index:2;">&times;</button><button id="pa-lightbox-prev" style="position:absolute;left:30px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.1);border:none;color:#fff;font-size:32px;line-height:1;cursor:pointer;font-family:Arial,sans-serif;padding:0;width:50px;height:50px;border-radius:50%;z-index:2;">&#8249;</button><button id="pa-lightbox-next" style="position:absolute;right:30px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.1);border:none;color:#fff;font-size:32px;line-height:1;cursor:pointer;font-family:Arial,sans-serif;padding:0;width:50px;height:50px;border-radius:50%;z-index:2;">&#8250;</button><img id="pa-lightbox-img" style="max-width:90vw;max-height:90vh;object-fit:contain;cursor:default;" alt="">';
  document.body.appendChild(overlay);

  var overlayImg = document.getElementById('pa-lightbox-img');
  var closeBtn = document.getElementById('pa-lightbox-close');
  var prevBtn = document.getElementById('pa-lightbox-prev');
  var nextBtn = document.getElementById('pa-lightbox-next');
  // Hover-zoom: scale image and pan based on cursor position
  overlayImg.addEventListener('mousemove', function(e) {
    var rect = overlayImg.getBoundingClientRect();
    var xPercent = ((e.clientX - rect.left) / rect.width) * 100;
    var yPercent = ((e.clientY - rect.top) / rect.height) * 100;
    overlayImg.style.transformOrigin = xPercent + '% ' + yPercent + '%';
    overlayImg.style.transform = 'scale(2.5)';
    overlayImg.style.cursor = 'zoom-out';
    overlayImg.style.transition = 'transform 0.1s ease-out';
  });
  
  overlayImg.addEventListener('mouseleave', function() {
    overlayImg.style.transform = 'scale(1)';
    overlayImg.style.cursor = 'default';
  });

  var galleryImages = [];
  var currentIndex = 0;

  function openLightbox(highRes, lowRes, index) {
    overlayImg.src = lowRes || highRes;
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    currentIndex = index || 0;

    if (lowRes && lowRes !== highRes) {
      var preloader = new Image();
      preloader.onload = function() {
        overlayImg.src = highRes;
      };
      preloader.src = highRes;
    }
  }

var navigating = false;
  
  function navigateLightbox(direction) {
    if (galleryImages.length === 0) return;
    if (navigating) return;
    navigating = true;
    setTimeout(function() { navigating = false; }, 250);
    
    currentIndex = (currentIndex + direction + galleryImages.length) % galleryImages.length;
    var img = galleryImages[currentIndex];
    var lowRes = img.currentSrc || img.src;
    var highRes = getCappedImageUrl(img);

    overlayImg.src = lowRes;
    if (lowRes !== highRes) {
      var preloader = new Image();
      preloader.onload = function() {
        overlayImg.src = highRes;
      };
      preloader.src = highRes;
    }
  }

  function closeLightbox() {
    overlay.style.display = 'none';
    overlayImg.src = '';
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', function(e) {
    if (e.target === overlayImg) return;
    if (e.target === prevBtn || e.target === nextBtn) return;
    closeLightbox();
  });

  closeBtn.addEventListener('click', closeLightbox);

var lastNavTime = 0;
  
  prevBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    var now = Date.now();
    if (now - lastNavTime < 200) return;
    lastNavTime = now;
    navigateLightbox(-1);
  });

  nextBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    var now = Date.now();
    if (now - lastNavTime < 200) return;
    lastNavTime = now;
    navigateLightbox(1);
  });

  document.addEventListener('keydown', function(e) {
    if (overlay.style.display !== 'flex') return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') navigateLightbox(-1);
    if (e.key === 'ArrowRight') navigateLightbox(1);
  });

  galleryImages = Array.prototype.slice.call(document.querySelectorAll('.product_gallery img')).filter(function(img) {
    return !img.closest('.product_gallery_nav');
  });

  galleryImages.forEach(function(img, index) {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var lowRes = this.currentSrc || this.src;
      openLightbox(getCappedImageUrl(this), lowRes, index);
    });
  });

});


// Resume slideshow after user interaction
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var slider = document.querySelector('.slideshow-wrapper');
    if (!slider) return;
    var flkty = Flickity.data(slider);
    if (!flkty) return;
    slider.addEventListener('pointerup', function() {
      setTimeout(function() { flkty.playPlayer(); }, 3000);
    });
    slider.addEventListener('touchend', function() {
      setTimeout(function() { flkty.playPlayer(); }, 3000);
    });
  }, 1000);
});

// Speed up Safari iOS back-navigation by handling bfcache restore
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    document.documentElement.classList.add('bfcache-restored');
    setTimeout(function() {
      window.scrollBy(0, 0);
    }, 0);
  }
});

// Strip commas from current_price after variant changes (product page only)
document.addEventListener('DOMContentLoaded', function() {
  var priceEl = document.querySelector('.product_section .current_price');
  if (!priceEl) return;
  
  function stripCommas() {
    var moneySpans = priceEl.querySelectorAll('.money');
    moneySpans.forEach(function(span) {
      if (span.textContent.indexOf(',') !== -1) {
        span.textContent = span.textContent.replace(/,/g, '');
      }
    });
  }
  
stripCommas();
  
  function flashPrice() {
    priceEl.style.animation = 'none';
    void priceEl.offsetWidth;
    priceEl.style.animation = 'priceFlash 0.6s ease';
  }
  
  var observer = new MutationObserver(function() {
    stripCommas();
    flashPrice();
  });
observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
});

// Mobile header offset shim (added 2026-05-27).
// -----------------------------------------------------------------------------
// `#header.mobile_nav-fixed--true` is position:fixed/top:0/z-index:1001. The
// theme's mobile CSS only pads `#pagecontent` with `padding-bottom: 40px`
// ($topMenuHeight), which (a) is on the wrong side to push content past the
// header and (b) hard-codes a value that no longer matches reality. After the
// 2026-05-27 nav modernization the rendered header is ~112px on mobile
// (promo_banner ~56 + top_bar ~56) — so the top ~80px of any first-on-page
// element (PDP gallery image, collection title, etc.) sits behind the fixed
// header and gets visually cropped.
//
// Fix: measure the actual fixed header height and apply it as body padding-top
// on mobile. Re-measures on resize, on promo-banner dismissal, and after any
// header DOM mutation (e.g. cart count change re-rendering the bag icon).
// Only runs when #header is actually position:fixed — so desktop and the
// transparent-header layouts are untouched.
(function () {
  function applyHeaderOffset() {
    var header = document.getElementById('header');
    var body = document.body;
    if (!header || !body) return;
    var isFixed = window.getComputedStyle(header).position === 'fixed';
    if (!isFixed) {
      body.style.paddingTop = '';
      return;
    }
    // Zero out the legacy `.page-banner { margin-top }` rule before
    // measuring — otherwise pages that have a page-banner would double-offset.
    body.style.paddingTop = header.offsetHeight + 'px';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeaderOffset);
  } else {
    applyHeaderOffset();
  }
  window.addEventListener('load', applyHeaderOffset);
  window.addEventListener('resize', applyHeaderOffset, { passive: true });
  // Re-measure if the header re-renders (promo banner close, cart update, etc).
  if (typeof MutationObserver !== 'undefined') {
    var headerEl = document.getElementById('header');
    if (headerEl) {
      new MutationObserver(applyHeaderOffset).observe(headerEl, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  }
})();

// Sticky price bar — show when main price is scrolled out of view.
// Stacks under the sticky_nav (header clone) when that's visible so the user
// keeps both the nav and the price/CTA in view.
document.addEventListener('DOMContentLoaded', function() {
  var stickyBar = document.getElementById('paStickyPrice');
  var mainPrice = document.querySelector('.product_section .modal_price');
  if (!stickyBar || !mainPrice) return;

  stickyBar.style.display = 'block';

  function positionUnderStickyNav() {
    // Mobile (<=768): the bar is pinned to the BOTTOM via CSS — never set an
    // inline top, which would override the bottom positioning.
    if (window.innerWidth <= 768) { stickyBar.style.top = ''; return; }
    // Desktop: stack under the Headhesive sticky_nav clone when it's visible.
    var stickyNav = document.querySelector('.main_nav_wrapper.sticky_nav.sticky_nav--stick');
    if (stickyNav && stickyNav.offsetHeight > 0) {
      stickyBar.style.top = stickyNav.offsetHeight + 'px';
      return;
    }
    // Mobile: #header is position:fixed at top:0 (mobile_nav-fixed--true), so
    // stack under that instead. offsetHeight on a hidden element is 0, so this
    // also handles desktop-without-sticky_nav (returns 0 as expected).
    var mobileHeader = document.getElementById('header');
    if (mobileHeader && mobileHeader.offsetHeight > 0 && window.getComputedStyle(mobileHeader).position === 'fixed') {
      stickyBar.style.top = mobileHeader.offsetHeight + 'px';
      return;
    }
    stickyBar.style.top = '0px';
  }

  function checkScroll() {
    var rect = mainPrice.getBoundingClientRect();
    if (rect.bottom < 0) {
      stickyBar.classList.add('is-visible');
      positionUnderStickyNav();
    } else {
      stickyBar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  window.addEventListener('resize', positionUnderStickyNav, { passive: true });
  checkScroll();

  // Single-variant PDPs render <button data-pa-sticky-add> instead of the
  // scroll anchor. Forward the click to the real Add to Cart button so we
  // inherit whatever the theme already does (ajax drawer, redirect, etc.) —
  // no duplicated cart logic to drift.
  var stickyAddBtn = stickyBar.querySelector('[data-pa-sticky-add]');
  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var realBtn = document.querySelector('.product_form button[name="add"]');
      if (realBtn) realBtn.click();
    });
  }
});